import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import AdbIcon from "@mui/icons-material/Adb";
import logo from "../../Assets/logo.webp";
import styles from "./Header.module.css";
import { Icon, styled } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import { Link } from "react-router-dom";

import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Parse from "../../API/ParseServer";
import { useCart } from "../../Context/CartContext";
const pages = [
  "GALLERY",
  "FRAMING",
  "PRINTING",
  "SHOP",
  "BLOGS",
  "MEMORABILIA",
];
// const settings = ["Profile", "Account", "Dashboard", "Logout"];

const CustomeMenu = styled(Menu)(({ theme }) => ({
  // width: "90% !important",

  "& .MuiMenu-paper": {
    width: "calc( 100% - 16px )",
    left: "16px !important",
  },
}));

const Header = () => {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null,
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null,
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const [userName, setUserName] = React.useState("");
  React.useEffect(() => {
    const user = Parse.User.current();
    if (user) setUserName(user.get("firstName"));
  }, [Parse.User.current()]);
  // const [totalQuantity, setTotalQuantity] = React.useState(0);
  const { totalQuantity } = useCart();
  // React.useEffect(() => {
  //   setTotalQuantity(Number(localStorage.getItem("totalQuantity")));
  // }, [localStorage.getItem("totalQuantity")]);
  const logoutHandler = () => {
    Parse.User.logOut();
    window.location.reload();
  };
  return (
    <AppBar
      position="sticky"
      sx={{
        backgroundColor: "#ebecef",
        color: "black",
        height: "6rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
      }}
    >
      <Box sx={{ width: "100%", px: { md: 8, xs: 1 } }}>
        <Toolbar disableGutters>
          <Link to={"/"}>
            <img src={logo} alt="logo" className={styles.logo} />
          </Link>
          <Link to={"/cart"}>
            <IconButton
              size="large"
              // aria-label="account of current user"
              // aria-controls="menu-appbar"
              // aria-haspopup="true"
              color="inherit"
              sx={{
                display: { xs: "flex", md: "none" },
                p: 0,
                pr: 1,
                position: "relative",
              }}
            >
              <ShoppingBagOutlinedIcon
                sx={{
                  color: "hsla(0, 0%, 0%, 0.658)",
                  ":hover": { backgroundColor: "transparent", color: "black" },
                  cursor: "pointer",
                }}
              />
              {totalQuantity > 0 && (
                <Typography
                  sx={{
                    backgroundColor: "#863a1d",
                    color: "white",
                    p: "3px 6px",
                    width: "1.3rem",
                    aspectRatio: 1,
                    borderRadius: "100%",
                    fontSize: 11,
                    position: "absolute",
                    bottom: -12,
                    right: 0,
                    textAlign: "center",
                  }}
                >
                  {totalQuantity}
                </Typography>
              )}
            </IconButton>
          </Link>
          {userName ? (
            <Box
              sx={{
                display: { xs: "flex", md: "none" },
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {" "}
              <Link to={"/profile"}>
                <IconButton
                  size="large"
                  color="inherit"
                  sx={{ display: { xs: "flex", md: "none" } }}
                >
                  <AccountCircleIcon
                    sx={{
                      color: "hsla(0, 0%, 0%, 0.658)",
                      ":hover": {
                        backgroundColor: "transparent",
                        color: "black",
                      },
                      cursor: "pointer",
                      p: 0,
                      m: 0,
                    }}
                  />
                </IconButton>
              </Link>
              {/* <Typography variant="subtitle1" sx={{ lineHeight: "20px" }}>
                Hi{" "}
                {userName.length > 4 ? `${userName.slice(0, 4)}...` : userName}
              </Typography> */}
            </Box>
          ) : (
            <Link to={"/login"}>
              <IconButton
                size="large"
                // aria-label="account of current user"
                // aria-controls="menu-appbar"
                // aria-haspopup="true"
                color="inherit"
                sx={{ display: { xs: "flex", md: "none" }, p: 0 }}
              >
                <AccountCircleIcon
                  sx={{
                    color: "hsla(0, 0%, 0%, 0.658)",
                    ":hover": {
                      backgroundColor: "transparent",
                      color: "black",
                    },
                    cursor: "pointer",
                  }}
                />
              </IconButton>
            </Link>
          )}

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              zIndex: 1000000,
            }}
          >
            <CustomeMenu
              id="menu-appbar"
              anchorEl={anchorElNav}
              // anchorOrigin={{
              //   vertical: "bottom",
              //   horizontal: "left",
              // }}
              keepMounted
              // transformOrigin={{
              //   vertical: "top",
              //   horizontal: "left",
              // }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <Link to={`/${page.toLocaleLowerCase()}`}>
                  <MenuItem key={page} onClick={handleCloseNavMenu}>
                    <Typography textAlign="center">{page}</Typography>
                  </MenuItem>
                </Link>
              ))}
              {/* <Box sx={{ width: "25ch", ml: 1 }}>
                <SearchBar />
              </Box> */}
            </CustomeMenu>
          </Box>
          <Link to={"/"}>
            <img src={logo} alt="logo" className={styles.mblogo} />
          </Link>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "end",
            }}
          >
            {pages.map((page) => (
              <Link to={`/${page.toLowerCase()}`}>
                <Button
                  key={page}
                  onClick={handleCloseNavMenu}
                  sx={{
                    my: 2,
                    color: "hsla(0, 0%, 0%, 0.658)",
                    display: "block",
                    ":hover": {
                      backgroundColor: "transparent",
                      color: "black",
                    },
                  }}
                >
                  {page}
                </Button>
              </Link>
            ))}
          </Box>
          <Box sx={{ display: "flex", flexGrow: 0, alignItems: "center" }}>
            {/* <Tooltip title="Open settings"> */}
            {/* <Box sx={{ display: { xs: "none", md: "block" } }}>
              <SearchBar />
            </Box> */}
            {userName ? (
              <Box
                sx={{
                  display: { xs: "none", md: "flex" },
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                {" "}
                <Link to={"/profile"}>
                  <IconButton
                    size="large"
                    // aria-label="account of current user"
                    // aria-controls="menu-appbar"
                    // aria-haspopup="true"
                    color="inherit"
                    sx={{ display: { xs: "none", md: "flex" } }}
                  >
                    <AccountCircleIcon
                      sx={{
                        color: "hsla(0, 0%, 0%, 0.658)",
                        ":hover": {
                          backgroundColor: "transparent",
                          color: "black",
                        },
                        cursor: "pointer",
                        p: 0,
                        m: 0,
                      }}
                    />
                  </IconButton>
                </Link>
                {/* <Typography variant="subtitle1" sx={{ lineHeight: "20px" }}>
                  Hi{" "}
                  {userName.length > 4
                    ? `${userName.slice(0, 4)}...`
                    : userName}
                </Typography> */}
              </Box>
            ) : (
              <Link to={"/login"}>
                <IconButton
                  size="large"
                  // aria-label="account of current user"
                  // aria-controls="menu-appbar"
                  // aria-haspopup="true"
                  color="inherit"
                  sx={{ display: { xs: "none", md: "flex" } }}
                >
                  <AccountCircleIcon
                    sx={{
                      color: "hsla(0, 0%, 0%, 0.658)",
                      ":hover": {
                        backgroundColor: "transparent",
                        color: "black",
                      },
                      cursor: "pointer",
                    }}
                  />
                </IconButton>
              </Link>
            )}

            <Link to={"/cart"}>
              <IconButton
                size="large"
                // aria-label="account of current user"
                // aria-controls="menu-appbar"
                // aria-haspopup="true"
                color="inherit"
                sx={{
                  display: { xs: "none", md: "flex" },
                  position: "relative",
                }}
              >
                <ShoppingBagOutlinedIcon
                  sx={{
                    color: "hsla(0, 0%, 0%, 0.658)",
                    ":hover": {
                      backgroundColor: "transparent",
                      color: "black",
                    },
                    cursor: "pointer",
                    // position: "relative",
                  }}
                />
                {totalQuantity > 0 && (
                  <Typography
                    sx={{
                      backgroundColor: "#863a1d",
                      color: "white",
                      p: "3px 6px",
                      width: "1.4rem",
                      aspectRatio: 1,
                      borderRadius: "100%",
                      fontSize: 11,
                      position: "absolute",
                      bottom: 1,
                      right: 1,
                      textAlign: "center",
                    }}
                  >
                    {totalQuantity}
                  </Typography>
                )}
              </IconButton>
            </Link>

            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              sx={{ display: { xs: "flex", md: "none" } }}
            >
              <MenuIcon />
            </IconButton>
            {/* <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" /> */}
            {/* </Tooltip> */}
            {/* <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu> */}
          </Box>
        </Toolbar>
      </Box>
    </AppBar>
  );
};
export default Header;
